import React from 'react';
import { BookOpen } from 'lucide-react';
import { createIframeGame } from './IframeGameActivity';

export default createIframeGame({
  id: 'koumori-sensei',
  displayName: 'Koumori Sensei',
  shortDescription: 'Interactive Japanese & Kanji learning game activity.',
  leaderboard: 'score',
  url: 'https://kanji-cave.pages.dev/',
  icon: BookOpen,
  attribution: {
    text: 'Koumori Sensei — Kanji Cave',
    license: 'Web Application',
    href: 'https://kanji-cave.pages.dev/',
  },
});
